// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class CounterpartyMerged extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  counterpartyId!: number;
  abn?: string;
  accountName?: string;
  accountNo?: string;
  altAddress?: string;
  altPayee?: string;
  altReference?: string;
  bankAddress?: string;
  bankId?: number;
  bankName?: string;
  bsb?: string;
  contextId?: number;
  counterpartyTypeId?: number;
  createdBy!: string;
  createdDate!: Date;
  exFlags?: number;
  firstName?: string;
  flags?: number;
  industryTypeId?: number;
  isIndividual!: boolean;
  lastName?: string;
  mchildCount!: number;
  muid?: string;
  name!: string;
  parentCounterpartyId?: number;
  pmuid?: string;
  portalTs?: string;
  reference1?: string;
  reference2?: string;
  reference3?: string;
  status!: number;
  title?: string;
  ts?: string;
  type?: number;
  uid!: string;
  updatedBy!: string;
  updatedDate!: Date;
  webData?: number;
  webFlags?: number;
}

